import React from 'react';
import { connect } from 'react-redux';
import CyberComponent from 'containers/CyberComponent';
import FormElement from 'components/FormElement';
import { handleInputChange } from 'actions/request';

class BillingPurchaseOrder extends CyberComponent {
  render() {
    const { request, handleInputChange, user } = this.props;
    const isEditable = user.canEditRequest && !request.isPaid;

    return (
      <FormElement
        type="text"
        id="billingOrderNum"
        label="Purchase Order Number"
        value={request.billingOrderNum}
        onChange={handleInputChange}
        placeholder="If applicable"
        editable={isEditable}
        maxLength={50}
      />
    );
  }
}

function mapStateToProps({ request, user }) {
  return { request, user };
}

export default connect(
  mapStateToProps,
  {
    handleInputChange
  }
)(BillingPurchaseOrder);



// WEBPACK FOOTER //
// ./src/containers/request/Initial/Steps/Vendor/BillingPurchaseOrder.js